.Main {
    position: relative;
    width: 100%;
    aspect-ratio: var(--aspect, 16 / 9);
    margin: 0 0 1.7em 0;
}

.Main iframe,
.Main video,
.Main embed,
.Main object {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}